module.exports = __webpack_public_path__ + "img/owlz_masterowlwax.cc20de7.png";